import { useObserver } from "mobx-react";
import {
  AiOutlineCloseCircle,
  AiOutlineCloudUpload,
  AiOutlineDelete,
} from "react-icons/ai";
import { BsStars } from "react-icons/bs";
import jd from "../../../assests/jd.png";
import { uploadFileToAzure } from "../../../services/azure";
import { useEffect, useRef, useState } from "react";
import { useStores } from "../../../store";
import GeneratePopup from "./GeneratePopup";
import { pdfjs } from "react-pdf";
import axios from "axios";
import { apiGet, apiPostPut } from "../../../api/api_methods";
import Description from "./Description";
import { createResumeScores } from "../../../api/recruiterResumeScoresApi";
import AlertPopup from "../../signup_2/alertPopup";
import { GetMoreCreditsPopUp } from "../../dashboard/basicDetails";
import { useNavigate } from "react-router-dom";
import UploadLoader from "../../reusble_components/uploadLoader";
import Success from "../../reusble_components/popup/success";

const data = [
  {
    name: "Balla Aravindh",
    mail: "aravindballa2002@gmail.com",
    Experience: "Fresher",
    score: 80,
    strength: `Java Expertise: The candidate has solid experience and skills in Java, including knowledge of core concepts and recent versions.
    
Framework Proficiency: They are well-versed in essential Java frameworks and tools like Spring and Hibernate, matching job needs.
    
Problem-Solving Skills: The candidate excels in troubleshooting and optimizing code, addressing complex issues effectively.
    `,
    project: `E-Commerce Platform: A scalable online shopping site with features like product catalog management, user authentication, payment processing, and order tracking.
  
Inventory Management System: A comprehensive system for managing stock levels, orders, and suppliers, often used by retail or warehouse businesses.  `,
    skills: ["React", "React", "React", "React"],
  },
  {
    name: "Balla Aravindh",
    mail: "aravindballa2002@gmail.com",
    Experience: "Fresher",
    score: 70,
  },
  {
    name: "Balla Aravindh",
    mail: "aravindballa2002@gmail.com",
    Experience: "Fresher",
    score: 20,
  },
  {
    name: "Balla Aravindh",
    mail: "aravindballa2002@gmail.com",
    Experience: "Fresher",
    score: 0,
  },
];

export default function Resume() {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

  const [loadermessage, setLoaderMessage] = useState("loading");
  const [loader, setLoader] = useState(false);
  const [showJD, setShowJD] = useState(false);

  const [fileName, setFileName] = useState([]);
  const [applicant, setApplicant] = useState({});
  const { PopupStore, RecuiterStore, UserStore } = useStores();
  const [file, setFile] = useState([]);
  const [count, setCount] = useState(0);
  const [Upload, setUpload] = useState(false);
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [Sorting, setSorting] = useState(false);
  const [fetching, setFetching] = useState(false);

  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data;

      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }
      console.log(fullText);
      return fullText;
    } catch (error) {
      console.error("Error fetching or parsing PDF file", error);
    }
  };

  useEffect(() => {
    return () => {
      RecuiterStore.setGeneratedJD("");
      RecuiterStore.setResumeScore([]);
      UserStore.getUserDetails();
    };
  }, []);

  const scroll = useRef(null);

  const scrollToBottom = () => {
    scroll.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handledrag = async (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;

    if (!files || files.length === 0) {
      console.error("No files detected.");
      return;
    }

    try {
      const filesArray = Array.from(files);

      const newFileNames = await Promise.all(
        filesArray.map(async (file) => {
          if (!file || file.size === 0) {
            console.error(`File ${file.name} is not accessible or empty.`);
            return null; // Skip inaccessible or empty files
          }

          if (!file.name.endsWith(".pdf") || file.size < 100) {
            console.error(`${file.name} is not a valid PDF or is too small.`);
            return null; // Skip non-PDF files or very small files
          }

          const reader = new FileReader();

          return new Promise((resolve, reject) => {
            reader.onload = async () => {
              try {
                const pdfData = new Uint8Array(reader.result);
                const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
                const numPages = pdf.numPages;
                console.log(`Number of pages in ${file.name}: ${numPages}`);
                resolve({ file, numPages });
              } catch (pdfError) {
                console.error(
                  `Error processing PDF ${file.name}:`,
                  pdfError.message,
                );
                resolve({ file, numPages: 0 }); // Optionally resolve with numPages: 0
              }
            };

            reader.onerror = () => {
              console.error(`Error reading file ${file.name}:`, reader.error);
              reject(reader.error);
            };

            reader.readAsArrayBuffer(file);
          });
        }),
      );

      // Filter out any null results from skipped files
      const validFileNames = newFileNames.filter((result) => result !== null);
      setFileName((prevFileNames) => [...prevFileNames, ...validFileNames]);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleFileChange = async (e) => {
    try {
      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      // const filesArray = Array.from(e.target.files);
      // const newFileNames = filesArray.map((file) => file);
      // setFileName((prevFileNames) => [...prevFileNames, ...newFileNames]);
      const filesArray = Array.from(e.target.files);
      const newFileNames = await Promise.all(
        filesArray.map(async (file) => {
          const reader = new FileReader();
          reader.readAsArrayBuffer(file);
          return new Promise((resolve, reject) => {
            reader.onload = async () => {
              const pdfData = new Uint8Array(reader.result);
              const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
              const numPages = pdf.numPages;
              console.log(`Number of pages in ${file.name}: ${numPages}`);
              resolve({ file, numPages });
            };
            reader.onerror = (error) => reject(error);
          });
        }),
      );
      setFileName((prevFileNames) => [...prevFileNames, ...newFileNames]);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleSubmit = async (save = false) => {
    try {
      setUpload(true);

      let resumefiles = [];
      const userCoins = JSON.parse(localStorage.getItem("user"))?.coins || 0;

      if (fileName.length * 5 > userCoins) {
        setUpload(false);
        PopupStore.setMessage(
          userCoins >= 5
            ? `You can upload only ${userCoins / 5} resumes`
            : "You don't have enough credits to check the resumes score",
        );
        PopupStore.setAlert(true);
        return;
      }

      if (RecuiterStore.generatedJD === "" && !save) {
        setUpload(false);

        PopupStore.setMessage("Please enter Job Description");
        PopupStore.setAlert(true);
        return;
      } else if (RecuiterStore.generatedJD.length < 20 && !save) {
        setUpload(false);
        PopupStore.setMessage(
          "Job Description should be atleast 20 characters",
        );
        PopupStore.setAlert(true);
        return;
      }

      RecuiterStore.setResumeCount(0);
      RecuiterStore.resumeLength = fileName.length;

      // Upload files and prepare resumefiles
      for (const file of fileName) {
        const timestamp = Date.now().toString();
        const randomNumber =
          Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
        const filenames = randomNumber + timestamp + file.file.name;

        const fileUploaded = await uploadFileToAzure(filenames, file.file, {
          action: "resume",
        });
        const text = await fetchData(fileUploaded.url);

        const body = {
          link: fileUploaded.url,
          content: text,
        };

        resumefiles.push(body);
        setFile((prev) => [...prev, body]);
        setCount(count + 1);
        RecuiterStore.setResumeCount(Number(RecuiterStore.resumeCount) + 1);
      }
      setUpload(false);

      setLoaderMessage("Saving");
      setLoader(true);

      const modelId =
        process.env.REACT_APP_IS_TEST_SERVER === "true"
          ? process.env.REACT_APP_LOW_MODEL_ID
          : process.env.REACT_APP_HIGH_MODEL_ID;

      console.log(
        process.env.REACT_APP_IS_TEST_SERVER,
        process.env.REACT_APP_LOW_MODEL_ID,
        process.env.REACT_APP_HIGH_MODEL_ID,
        "sai",
      );

      // Create JD and resume info
      const body = {
        createdBy: JSON.parse(localStorage.getItem("user"))?._id,
        // model: 1,
        cluster: JSON.parse(localStorage.getItem("user"))?.cluster,
        model: modelId,
        jd: RecuiterStore.generatedJD,
        resumes: [], // Initialize with empty array
      };
      // alert("hii");

      if (RecuiterStore?.generateParams?.title) {
        body.name = RecuiterStore?.generateParams?.title;
      }
      if (resumefiles.length === 0) {
        setLoader(false);
        alert("Please upload resumes");
        return;
      }

      const res = await apiPostPut(
        body,
        "/jds/create-jd-and-resumeinfo",
        "POST",
      );

      if (res.status === 200) {
        RecuiterStore.setJDID(res.body.jd._id);
        //set jdid to local storage
        localStorage.setItem("jdId", res.body.jd._id);
        UserStore.getUserDetails(true);
        // RecuiterStore.setLoader(true);

        // Batch upload resumes in chunks of 20
        const chunkSize = 10;
        let totalResumesUploaded = 0;

        for (let i = 0; i < resumefiles.length; i += chunkSize) {
          const chunk = resumefiles.slice(i, i + chunkSize);
          const chunkBody1 = { resumes: chunk, isSave: save };
          const chunkBody2 = { resumes: chunk, isSort: !save, isSave: !save };

          const chunkBody = save ? chunkBody1 : chunkBody2;
          const chunkRes = await createResumeScores(res.body.jd._id, chunkBody);

          if (chunkRes.status !== 200) {
            alert(chunkRes.body?.message);
            break; // Stop if there's an error in uploading a chunk
          }

          totalResumesUploaded += chunk.length;
          // RecuiterStore.setLoader(true);

          // Optional: Add a delay between batches if needed
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
        if (save) {
          setLoader(false);
          setLoaderMessage("");
          RecuiterStore.setJDId(res.body.jd._id);
          RecuiterStore.setJDType("saved");
          PopupStore.setSuccessPopup(true);
          return;
        }

        setLoaderMessage("Sorting");

        // const response = await createResumeScores(res.body.jd._id, {});

        // if (response.status === 200) {
        // Show Timer Component Here
        // showTimerComponent();
        // const delay = count < 20 ? 20000 : 60000; // 20 seconds or 60 seconds

        // await new Promise((resolve) => setTimeout(resolve, delay));

        // setLoaderMessage("Fetching");

        // await new Promise((resolve) => setTimeout(resolve, 10000));

        setLoader(false);
        setLoaderMessage("");
        RecuiterStore.setJDId(res.body.jd._id);
        PopupStore.setSuccessPopup(true);
        RecuiterStore.setResumeScore([]);
        RecuiterStore.setGeneratedJD("");
        setFileName([]);
        setFile([]);
        RecuiterStore.setJDName("");
        RecuiterStore.ClearGenerateParams();
        setShowJD(false);
        // navigate(`/company/resumescore/${res.body.jd._id}`);
        // } else {
        //   PopupStore.setMessage(
        //     userCoins >= 5
        //       ? `You can upload only ${userCoins / 5} resumes`
        //       : "You don't have enough credits to check the resumes score"
        //   );
        //   PopupStore.setAlert(true);
        //   alert(response.body?.message);
        //   setUpload(false);
        // }
      } else {
        alert(res.body?.message);
        setUpload(false);
      }

      setUpload(false);
    } catch (error) {
      setUpload(false);
      setUpload(false);
      console.error("Error uploading file:", error);
    }
  };

  const showTimerComponent = () => {
    let remainingTime = 10;

    const timerInterval = setInterval(() => {
      if (remainingTime > 0) {
        PopupStore.setMessage(
          `Sorting your Resumes. Please wait... ${remainingTime} seconds remaining.`,
        );
        PopupStore.setAlert(true);
        remainingTime -= 1;
      } else {
        clearInterval(timerInterval);
        PopupStore.setAlert(false);
        RecuiterStore.fetchResumeScore(0, RecuiterStore.jdId, 10);
        RecuiterStore.fetchjd();
        setTimeout(() => {
          scrollToBottom();
        }, 2000);
      }
    }, 1000);
  };

  return useObserver(() => {
    return (
      <>
        <Success />
        <AlertPopup />
        <UploadLoader
          load={Upload}
          mess={"Uploading"}
          count={(
            ((RecuiterStore.resumeCount / fileName.length) * 100) /
            4
          ).toFixed(0)}
        />
        <UploadLoader
          load={loader}
          mess={loadermessage}
          count={
            loadermessage === "Saving"
              ? 25
              : loadermessage === "Sorting"
                ? 50
                : loadermessage === "Fetching"
                  ? 75
                  : ""
          }
          len={fileName.length}
        />
        {PopupStore.getMoreCredits && (
          <GetMoreCreditsPopUp
            popUpInitialValue={PopupStore.getMoreCredits}
            handlePopup={() => {
              PopupStore.setGetMoreCredits(false);
            }}
            referAndEarnHide={true}
          />
        )}
        <GeneratePopup />
        {/* <Loader loader={RecuiterStore.loader} /> */}

        <div className="md:p-8 p-4 md:px-16 h-full overflow-y-scroll  no-scrollbar ">
          <div className="flex flex-col h-full md:gap-6 gap-2 mb-32 md:mt-2 lg:mt-2">
            <div className="flex items-center justify-between">
              <span className="text-3xl font-bold text-primary">
                Resume Analyzer
              </span>
              {/* <div className="items-center justify-between pr-4  rounded-lg border-[#FF6B00] border w-full md:w-[300px] hidden md:flex lg:flex">
                <input
                  type="text"
                  placeholder="search by name,label...."
                  className="w-full py-3 pl-4 pr-8 text-sm outline-none text-gray-600 rounded-lg"
                />
                <IoSearchOutline className="text-[#FF6B00]" />
              </div> */}
            </div>
            <ResumeUploader
              fileName={fileName}
              newsort={true}
              setFileName={setFileName}
              handleFileChange={handleFileChange}
              handledrag={handledrag}
              handleSubmit={handleSubmit}
              Upload={Upload}
            />
            {!showJD && (
              <div className="w-full flex justify-end items-center gap-3 font-semibold">
                <button
                  className="border border-primary text-primary h-11 w-32 rounded-xl"
                  onClick={() => handleSubmit(true)}
                >
                  Save Only
                </button>
                <button
                  className="bg-primary text-white h-11 w-32 rounded-xl ml-2"
                  onClick={() => setShowJD(true)}
                >
                  Sort Now
                </button>
              </div>
            )}
            {/* <JDCards /> */}
            {showJD && (
              <div className="flex flex-col gap-4">
                <span className="flex font-semibold  flex-row justify-between items-center gap-4">
                  <p className="text-lg">Enter your Job Description</p>
                  <button
                    className="p-1.5 rounded-xl text-primary font-semibold border border-primary flex items-center gap-2"
                    onClick={() => {
                      RecuiterStore.ClearGenerateParams();
                      PopupStore.setGenerate(true);
                    }}
                  >
                    <BsStars />
                    Auto generate
                  </button>
                </span>
                <Description />
                <div className="w-full flex justify-end items-center gap-4 font-semibold">
                  <button
                    className="bg-primary text-white h-11 w-32 rounded-lg ml-2"
                    onClick={() => handleSubmit()}
                  >
                    Sort Now
                  </button>
                </div>
              </div>
            )}

            {/* {RecuiterStore.resumeScore?.data?.resumes && (
              <div className="w-full " ref={scroll}>
                <ResumeTable />
              </div>
            )} */}
          </div>
        </div>
      </>
    );
  });
}

// New ResumeUploader Component
export const ResumeUploader = ({
  fileName,
  newsort,
  setFileName,
  handleFileChange,
  handledrag,
  handleSubmit,
  addedResumes = false,
  Upload = false,
}) => {
  const { PopupStore, RecuiterStore, UserStore } = useStores();
  useEffect(() => {
    console.log(fileName, "sai");
  }, [fileName]);
  return (
    <div
      className={`flex justify-center py-5 ${
        fileName?.length === 0 && "items-center"
      } border border-dashed border-spacing-2 border-opacity-50 z-30 rounded-lg relative border-black h-[70vh]`}
      style={{ borderWidth: "2px", borderSpacing: "10px" }}
      onDragOver={(e) => e.preventDefault()}
      onDrop={handledrag}
    >
      <input
        type="file"
        id="header"
        name="header"
        onChange={handleFileChange}
        className=" inset-0 opacity-0 w-2 h-full cursor-pointer"
        accept=".pdf"
        multiple
      />
      {fileName?.length === 0 ? (
        <div className="flex flex-col gap-4  font-semibold items-center h-full w-full justify-center">
          <img src={jd} className="w-80" />
          <button
            className="flex gap-2 p-2 justify-center items-center bg-primary text-white px-6 rounded-lg"
            onClick={() => document.getElementById("header").click()}
          >
            <AiOutlineCloudUpload />
            {addedResumes ? "Add files" : "Upload files"}
          </button>
          <p>You can Drag & Drop or choose files</p>
        </div>
      ) : (
        <div className="w-full h-full px-4 pb-4">
          <div
            className="flex flex-wrap w-full max-h-[53vh] gap-4 my-5 overflow-scroll"
            style={{ scrollbarWidth: "none" }}
          >
            {fileName?.map((e, index) => (
              <div
                key={index}
                className={`border flex items-center z-30 gap-2 h-10 rounded-lg  p-2 ${
                  e.numPages <= 10 ? "border-green-500" : "border-red-500"
                } `}
              >
                <span className="max-w-[12rem] truncate">{e?.file?.name}</span>
                {/* <span className="text-xs">{e}</span> */}
                <AiOutlineCloseCircle
                  className="cursor-pointer"
                  onClick={() => {
                    const updatedList = fileName.filter((item) => item !== e);
                    setFileName(updatedList);
                  }}
                />
              </div>
            ))}
          </div>
          <div className="flex absolute bottom-2 flex-col justify-end min-h-[100%] md:w-full w-[90%] ">
            <p>
              {fileName.some((e) => e.numPages > 10) && (
                <p className="text-red-500 mb-5">
                  Some resumes exceed the 10-page limit. Please remove them
                  before submitting.
                </p>
              )}
            </p>
            <div className="flex gap-2 flex-col md:flex-row md:items-center mr-4 justify-start md:justify-between">
              <div className="flex justify-between ">
                <button
                  className="flex items-center gap-1 text-primary "
                  onClick={() => document.getElementById("header").click()}
                >
                  <AiOutlineCloudUpload />
                  {addedResumes ? "Add more resumes" : "Upload more resumes"}
                </button>
              </div>
              <div className="flex justify-between mr-2 md:gap-5 md:mr-6">
                {fileName.length > 0 && (
                  <div className="flex justify-between ">
                    <span
                      className="flex items-center justify-between gap-2 cursor-pointer"
                      onClick={() => setFileName([])}
                    >
                      <AiOutlineDelete className="text-primary" /> clear all
                    </span>
                  </div>
                )}
                {!newsort && (
                  <button
                    className={` text-white  md:p-1 md:px-2 p-1 rounded-lg md:mr-8 mr-6 ${
                      fileName.some((e) => e.numPages > 10)
                        ? "bg-gray-300 cursor-not-allowed"
                        : " bg-primary cursor-pointer"
                    }`}
                    // if any of the resume has more than 10 pages, then disable the button
                    disabled={fileName.some((e) => e.numPages > 10)}
                    onClick={() => {
                      if (fileName.some((e) => e.numPages > 10)) {
                        alert(
                          "Some resumes exceed the 10-page limit. Please remove them before submitting.",
                        );
                      } else {
                        handleSubmit();
                      }
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* {Upload ? (
        <div className="flex absolute bottom-5 right-5 justify-end">
          <span>
            {RecuiterStore.resumeCount} out of {fileName.length}
            <div className="w-[10rem] rounded-full bg-primary bg-opacity-30 h-[1rem]">
              <div
                className="h-full rounded-full bg-primary"
                style={{
                  width: `${
                    (RecuiterStore.resumeCount / fileName.length) * 100
                  }%`,
                }}
              ></div>
            </div>
          </span>
        </div>
      ) : (
        <div className="flex absolute bottom-5 right-5 justify-end">
          <span>
            {fileName.length > 0 && <>{fileName.length} Resume Selected</>}
            <div className="w-[10rem] rounded-full bg-primary bg-opacity-30 h-[1rem]">
              <div
                className="h-full rounded-full bg-primary"
                style={{
                  width: `${
                    (RecuiterStore.resumeCount / fileName.length) * 100
                  }%`,
                }}
              ></div>
            </div>
          </span>
        </div>
      )} */}
    </div>
  );
};
